// extracted by mini-css-extract-plugin
export var icon = "_7m-1";
export var subtext = "_7m-0";